import { CalendlyButton } from "@/components/landing/CalendlyButton";
import { Reveal, RevealGroup, RevealItem } from "@/components/landing/Reveal";

const STEPS = [
  {
    n: "01",
    title: "Schedule a Free Consultation",
    body: "I\u2019ll lead the conversation, asking questions about your business, your bookkeeping concerns, and what brought you to Brown & Associates.",
  },
  {
    n: "02",
    title: "Determine What You Need",
    body: "If your needs are straightforward, we can discuss the appropriate ongoing service. If your books require closer examination, a paid diagnostic may be recommended.",
  },
  {
    n: "03",
    title: "Receive a Path Forward",
    body: "You will know the appropriate next step, whether that is ongoing bookkeeping, cleanup work, or a detailed review and action plan.",
  },
];

export const Process = () => (
  <section
    id="process"
    data-testid="process-section"
    className="bg-warm-neutral py-24 md:py-32"
  >
    <div className="container-page">
      <Reveal>
        <p className="font-body text-xs sm:text-sm uppercase tracking-[0.25em] text-navy-700 mb-5">
          Simple, no obligation
        </p>
        <h2 className="font-heading font-semibold text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-navy-900">
          What Happens <span className="italic font-normal">Next?</span>
        </h2>
      </Reveal>

      <RevealGroup className="mt-14 divide-y divide-navy-900/10 border-t border-navy-900/10">
        {STEPS.map((step) => (
          <RevealItem key={step.n}>
            <div
              data-testid={`process-step-${step.n}`}
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 group"
            >
              <div className="md:col-span-3">
                <span className="font-heading text-6xl md:text-7xl text-transparent [-webkit-text-stroke:1.25px_hsl(226,50%,10%)] opacity-60 group-hover:opacity-100 transition-opacity duration-500">
                  {step.n}
                </span>
              </div>
              <div className="md:col-span-9 max-w-2xl">
                <h3 className="font-heading text-2xl sm:text-3xl text-navy-900 leading-tight">
                  {step.title}
                </h3>
                <p className="font-body text-base sm:text-lg leading-relaxed text-navy-900/70 mt-3">
                  {step.body}
                </p>
              </div>
            </div>
          </RevealItem>
        ))}
      </RevealGroup>

      <Reveal delay={0.1}>
        <div className="mt-12">
          <CalendlyButton testId="process-cta-button" variant="dark" size="lg">
            Schedule My Free Consultation
          </CalendlyButton>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Process;
